import Typography from "@mui/material/Typography";

import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

import { subTypes } from "../itemTypes";
import useClasses from "../../useClasses";

const styles = (theme) => ({
  radioIcon: {
    color: theme.palette.text.secondary,
    width: theme.spacing(3),
    height: theme.spacing(3),
    //textAlign: "center",
    display: "flex",
    alignItems: "center",
  },
});

export default function OptionIcon({ type, option, index = 0 }) {
  const classes = useClasses(styles);
  switch (type) {
    case subTypes.singleChoice:
    case subTypes.yesno:
      return <RadioButtonUncheckedIcon className={classes.radioIcon} />;

    case subTypes.multipleChoice:
    case subTypes.bodyParts:
    case subTypes.multiSmiley:
      return <CheckBoxOutlineBlankIcon className={classes.radioIcon} />;

    case subTypes.order:
      return (
        <Typography variant="body2" className={classes.radioIcon}>
          {index + 1}.
        </Typography>
      );

    case subTypes.likert:
      return (
        <Typography variant="body2" className={classes.radioIcon}>
          {option.number}
        </Typography>
      );

    default:
      return "";
  }
}
